import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ArtCarousel from '../components/ArtCarousel';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="min-h-screen flex items-center justify-center px-6 pt-20 bg-white">
          <div className="max-w-7xl mx-auto w-full">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              {/* Left side - Eye artwork */}
              <div className="flex justify-center lg:justify-start order-2 lg:order-1">
                <div className="w-full max-w-lg">
                  <img
                    src="https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/n6f3hxlf_Home%20Page%20Image.jpeg"
                    alt="Eye Illustration"
                    className="w-full h-auto"
                  />
                </div>
              </div>

              {/* Right side - Text content */}
              <div className="space-y-8 order-1 lg:order-2">
                <div className="space-y-4">
                  <h1
                    className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight"
                    style={{ fontFamily: 'DM Sans, sans-serif' }}
                  >
                    Hey,
                    <br />
                    I am Ruchi Patel
                  </h1>
                  <p className="text-xl md:text-2xl text-gray-600 font-medium">
                    UX/UI Designer
                  </p>
                </div>

                <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-xl">
                  I design with a focus on simplicity, clarity, and human connection.
                  Coming from an architectural background, I approach digital experiences
                  as structured systems—where every element has purpose and guides users
                  intuitively.
                </p>

                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 pt-4">
                  <Button
                    onClick={() => navigate('/work')}
                    size="lg"
                    className="bg-[#EA8649] hover:bg-[#d97640] text-white transition-all duration-300 hover:scale-105"
                  >
                    View My Work
                    <ArrowRight className="ml-2" size={20} />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Featured Project Section */}
        <section className="py-24 px-6 bg-gray-50">
          <div className="max-w-7xl mx-auto">
            <div className="mb-12">
              <h2
                className="text-4xl md:text-5xl font-bold mb-4"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                Featured Project
              </h2>
              <p className="text-gray-600 text-lg">Latest UX/UI Design Work</p>
            </div>

            <div
              className="bg-white rounded-2xl shadow-lg overflow-hidden cursor-pointer hover:shadow-xl transition-shadow duration-300"
              onClick={() => navigate('/work')}
            >
              <div className="p-8">
                <img
                  src="https://customer-assets.emergentagent.com/job_plant-care-guide-12/artifacts/50uk8o04_Main%20Page.png"
                  alt="PlaCare Project"
                  className="w-full h-auto rounded-lg"
                />
              </div>
              <div className="px-8 pb-8">
                <h3 className="text-3xl font-bold mb-2" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                  PlaCare
                </h3>
                <p className="text-xl text-gray-600 mb-4">Plant Care Made Simple</p>
                <p className="text-gray-700 mb-6">
                  A mobile app designed to help plant owners easily identify, care for, and manage
                  their plants through simple, guided actions.
                </p>
                <Button
                  onClick={() => navigate('/work')}
                  className="bg-[#EA8649] hover:bg-[#d97640] text-white"
                >
                  View Case Study
                  <ArrowRight className="ml-2" size={18} />
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* Art Carousel Section */}
        <ArtCarousel navigate={navigate} />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;